import { Button } from "react-aria-components"
import { modalSignal } from "./ModalContainer"
import infoIcon from "../../../assets/icons/icon-information.svg"
import LoadingButton from "../LoadingButton"
import { useState } from "react"
import PrintPackingBoxReturnList from "../print/PrintPackingBoxReturnList"
import { httpPost } from "../../../modules/Backend"
import { EntityNames } from "../../../enums/EntityNames"
import { HttpStatusCode } from "axios"
import { toast } from "react-toastify"

interface IReturnPackingBoxesModal {
    cancelFunc?: Function
    autoClose?: boolean | null | undefined,
    entitiesToReturn: string[]
}

interface PackingBoxInfo {
    id: string;
    reference: string;
}

export default function ReturnPackingBoxesModal({ cancelFunc, autoClose, entitiesToReturn }: IReturnPackingBoxesModal) {
    const [loading, setLoading] = useState<boolean>(false);
    const [movedPackingBoxes, setMovedPackingBoxes] = useState<PackingBoxInfo[]>([]);
    const [isSuccess, setIsSuccess] = useState<boolean>(false);

    function buildViewUrl(packingBoxId: string): string {
        const baseUrl = window.location.origin;
        const viewPath = `/view/${EntityNames.packingBox}/${packingBoxId}`;
        return `${baseUrl}${viewPath}`;
    }

    function handleViewBox(packingBoxId: string) {
        const url = buildViewUrl(packingBoxId);
        window.open(url, "_blank");
    }

    async function handleContinue() {
        setLoading(true);
        const payLoad = {
            packingBoxIds: entitiesToReturn
        };
        const result = await httpPost(`api/${EntityNames.packingBox}/moveToOriginalOuterCubes`, payLoad)
        if (result.status === HttpStatusCode.Ok) {
            const movedBoxes = result.data.movedPackingBoxes || [];
            toast.success(`${movedBoxes.length} boxes returned!`, { position: "top-center" });
            setMovedPackingBoxes(movedBoxes);
            setIsSuccess(true);
        }
        setLoading(false);
        // Don't auto-close on success - let user see the list
    }

    function handleCancel() {
        modalSignal.value = undefined;
        if (cancelFunc) {
            cancelFunc();
        }
    }

    function handleClose() {
        modalSignal.value = undefined;
        if (cancelFunc) {
            cancelFunc();
        }
    }

    if (isSuccess) {
        return (
            <div className="display--flex flex__direction--column alignItems--center gap--xs return-packing-boxes-modal">
                <img src={infoIcon} />
                <h1>Boxes Returned Successfully</h1>
                <p className="textAlign--center margin__top--s">
                    {movedPackingBoxes.length} packing box{movedPackingBoxes.length === 1 ? '' : 'es'} {movedPackingBoxes.length === 1 ? 'was' : 'were'} moved to {movedPackingBoxes.length === 1 ? 'its' : 'their'} original pallet{movedPackingBoxes.length === 1 ? '' : 's'}.
                </p>
                {movedPackingBoxes.length > 0 && (
                    <div className="return-packing-boxes-modal__table-wrapper">
                        <table className="return-packing-boxes-modal__table">
                            <thead>
                                <tr>
                                    <th><p className="small">Reference</p></th>
                                    <th><p className="small">Action</p></th>
                                </tr>
                            </thead>
                            <tbody>
                                {movedPackingBoxes.map((box) => (
                                    <tr key={box.id}>
                                        <td><p className="small">{box.reference}</p></td>
                                        <td>
                                            <button
                                                className="button button--text-only"
                                                onClick={() => handleViewBox(box.id)}
                                            >
                                                <p className="button-text">View returned box</p>
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
                <div className="margin__top--s display--flex gap--xs">
                    <Button className="button button--large button--primary button--with-icon" onPress={handleClose}>
                        <p className="button-text">Close</p>
                    </Button>
                </div>
            </div>
        );
    }

    return (
        <div className="display--flex flex__direction--column alignItems--center gap--xs">
            <img src={infoIcon} />
            <h1>Return Boxes To Original Pallets</h1>
            <p className="textAlign--center whitespace--pre-line margin__top--s">{entitiesToReturn.length} box{entitiesToReturn.length === 1 ? '' : 'es'} proposed for return</p>
            <p className="textAlign--center whitespace--pre-line textDecoration--italics">Only boxes not already in their original pallets, will be processed.</p>
            <p className="textAlign--center whitespace--pre-line textDecoration--italics">If you cannot see a box in the print view, then it has been skipped.</p>
            <p className="textAlign--center whitespace--pre-line textDecoration--italics">Upon moving, refresh the page to see updates.</p>
            <div className="margin__top--xs display--flex gap--xs margin__top--s">
                <Button className=" button button--large button--secondary button--with-icon" onPress={handleCancel} isDisabled={loading}>
                    <p className="button-text">Cancel</p>
                </Button>
                <PrintPackingBoxReturnList packingBoxIds={entitiesToReturn} />
                <LoadingButton className="button button--large button--primary button--with-icon margin__left--xl"
                    onPress={async () => await handleContinue()}
                    buttonText="Confirm"
                    loadingText="Confirming"
                    isDisabled={loading}
                    isLoading={loading}>
                    <></>
                </LoadingButton>
            </div>
        </div>)
}


